module.exports = __webpack_public_path__ + "static/img/20-1.becec40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20-1.jpg
// module id = XmzW
// module chunks = 0